import { render, staticRenderFns } from "./googleauthenticate.vue?vue&type=template&id=6a4b2066&scoped=true&"
import script from "./googleauthenticate.vue?vue&type=script&lang=js&"
export * from "./googleauthenticate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a4b2066",
  null
  
)

export default component.exports